export default "__VITE_ASSET__B10XfXR6__"